Namespace 'Models'

class Models.InstagramMedia
  constructor: (type, url, name) ->
    @type = type
    @url = url
    @name = name
